export const CompanyActionTypes = {

    GET_COMPANY_DATA_FIRST: '@@company/GET_COMPANY_DATA_FIRST',
    GET_COMPANY_DATA_LOADING: '@@company/GET_COMPANY_DATA_LOADING',
    GET_COMPANY_DATA_SUCCESS: '@@company/GET_COMPANY_DATA_SUCCESS',
    GET_COMPANY_DATA_ERROR: '@@company/GET_COMPANY_DATA_ERROR',

    GET_COMPANY_DETAILS_DATA_FIRST: '@@company/GET_COMPANY_DETAILS_DATA_FIRST',
    GET_COMPANY_DETAILS_DATA_LOADING: '@@company/GET_COMPANY_DETAILS_DATA_LOADING',
    GET_COMPANY_DETAILS_DATA_SUCCESS: '@@company/GET_COMPANY_DETAILS_DATA_SUCCESS',
    GET_COMPANY_DETAILS_DATA_ERROR: '@@company/GET_COMPANY_DETAILS_DATA_ERROR',

    CREATE_COMPANY_DATA_FIRST: '@@company/CREATE_COMPANY_DATA_FIRST',
    CREATE_COMPANY_DATA_LOADING: '@@company/CREATE_COMPANY_DATA_LOADING',
    CREATE_COMPANY_DATA_SUCCESS: '@@company/CREATE_COMPANY_DATA_SUCCESS',
    CREATE_COMPANY_DATA_ERROR: '@@company/CREATE_COMPANY_DATA_ERROR',

    UPDATE_COMPANY_DATA_FIRST: '@@company/UPDATE_COMPANY_DATA_FIRST',
    UPDATE_COMPANY_DATA_LOADING: '@@company/UPDATE_COMPANY_DATA_LOADING',
    UPDATE_COMPANY_DATA_SUCCESS: '@@company/UPDATE_COMPANY_DATA_SUCCESS',
    UPDATE_COMPANY_DATA_ERROR: '@@company/UPDATE_COMPANY_DATA_ERROR',

    DELETE_COMPANY_DATA_FIRST: '@@company/DELETE_COMPANY_DATA_FIRST',
    DELETE_COMPANY_DATA_LOADING: '@@company/DELETE_COMPANY_DATA_LOADING',
    DELETE_COMPANY_DATA_SUCCESS: '@@company/DELETE_COMPANY_DATA_SUCCESS',
    DELETE_COMPANY_DATA_ERROR: '@@company/DELETE_COMPANY_DATA_ERROR',


    RESET_COMPANY_STATE: '@@company/RESET_COMPANY_STATE',

}